import React,{useState} from 'react'
import { Card, CardHeader, CardBody, Row, Col, CardImg, Button, Modal, ModalBody, FormGroup, Input, ModalFooter, Progress, Label,Form} from "reactstrap";
import Switch from "react-switch";
import { updatePermissions } from 'network/ApiAxiosTickets';
import ToastComp from 'components/Reusable Components/ToastComp';
import { ddns}  from "../../../../package.json";

function SellerPermissionCard(props) {
    const [active, setActive] = useState(props.seller.active);
    const [activeCategories, setactiveCategories] = useState(props.seller.sellerCategories);
    const [toast, setToast] = useState(false);
    const [limit, setLimit] = useState(props.seller.limit ? props.seller.limit : 0);

    const displaySellerCats =()=>{
        if(!props.categories) return
        return props.categories.map((categoryItem)=>{
            let categoryCheck = activeCategories.includes(categoryItem._id)
            const changeCategories = (catID,catExists)=>{
                if(catExists){
                    setactiveCategories(activeCategories.filter(item => item !== catID));
                }else{
                    setactiveCategories([...activeCategories, catID]);
                }
                
            }
            return <Row key={"checkRow" + props.seller._id + categoryItem._id}>
                <Input id={"check" + props.seller._id + categoryItem._id} onChange={()=>changeCategories(categoryItem._id,categoryCheck)} checked={categoryCheck} name="check" type="checkbox" />
                <Label check for={"check" + props.seller._id + categoryItem._id} >
                {categoryItem.name}
                </Label>
            </Row>
        })
    }

    const savePermissions = async()=>{
        const resp=await updatePermissions(props.seller._id,active,activeCategories,limit)
        if(resp.data.success){
            setToast({title:'Updated',text:'Seller permissions updated'})
        }else{
            setToast({title:'Failed',text:'Something went wrong please try again later'})
        }
    }

    const role = JSON.parse(localStorage.getItem('user')).role

  return (
    <Card className="shadow" style={{ width: '18rem'}}>
        <CardHeader>
            <CardImg
                style={{borderRadius: "150px", maxHeight:'200px', maxWidth:'200px'}}
                alt="Card image cap"
                src={props.seller.picture ? ddns + "/userfiles/" + props.seller.email + "/pics/" + props.seller.picture : require("assets/img/theme/team-1-800x800.jpg").default}
                top
            />
            <Row className='mt-2'>
                <Col>
                    <h3 className="mb-0" >{props.seller.name} </h3>
                </Col>
                <Col>
                    <Label>
                        Active:
                        <Switch onChange={()=>setActive(!active)} checked={active} />
                    </Label>
                </Col>
            </Row>
        </CardHeader>
        <CardBody>
            <Row>
                
            </Row>
            <Col>
                {displaySellerCats()}
                {role == 'admin' &&
                <Row className='mt-4'>
                    <Label>Deposit Limit
                    <Input type='number' value={limit} onChange={(e)=> setLimit(e.target.value)}/>
                    </Label>
                </Row>
                }
            </Col>
            <Row className=' justify-content-center'>
                <Button className='mt-2' color="primary" onClick={savePermissions}>Save</Button>
            </Row>
        </CardBody>
        {toast && <ToastComp type='primary' title={toast.title} text={toast.text} />}
    </Card>
  )
}

export default SellerPermissionCard

